module.exports = __webpack_public_path__ + "static/img/city-mob-red-2.8092892.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/city-mob-red-2.png
// module id = 1248
// module chunks = 4